import searchView from "../views/searchView";
export function searchViewLogic(store, mainContent) {
    viewRendering(mainContent);
    searchEvent();
}
//view rendering
function viewRendering(mainContent) {
    mainContent.innerHTML = searchView();
}
function searchEvent() {
    var searchButton = document.getElementById("search-view-button");
    var searchInput = document.getElementById("search-view-input");
    searchButton.addEventListener("click", function (event) {
        event.preventDefault();
        window.location.hash = "#/productList?search=" + searchInput.value;
    });
}
